var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { GlobalContext } from "@/contexts";
import { useContext } from "react";
import { LinkWithText } from "@/components/LinkComponents/LinkWithText";
import { getLinksForAnchor } from "@/components/utils";
export function AnchorLink(props) {
    var properties = useContext(GlobalContext).properties;
    var link = getLinksForAnchor(props.anchor, properties);
    if (!link) {
        return null;
    }
    return _jsx(LinkWithText, __assign({}, link, { variant: props.variant }));
}
